import { render, staticRenderFns } from "./PlatformManagement.vue?vue&type=template&id=c1c82bda"
import script from "./PlatformManagement.vue?vue&type=script&lang=js"
export * from "./PlatformManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports